import React from "react";
import Home from "../Pages/Home";
import About from "../Pages/About";
import Technologies from "../Pages/Technologies";
import Projects from "../Pages/Projects";
import Contact from "../Pages/Contact";

function Content() {
  return (
    <>
      <Home />
      <About />
      <Technologies />
      <Projects />
      <Contact />
    </>
  );
}

export default Content;
